<div class="btn-group">
    <button class="navbar-button" data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fal fa-question-circle"></i>
    </button>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        <li class="dropdown-item" (click)="openManuals()">
            <span class="icon">
                <i class="fas fa-books"></i>
            </span>
            <span class="text">Product Documentation</span>
            <span class="icon">
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </span>
        </li>
        <li class="dropdown-item" (click)="openApiManuals()">
            <span class="icon">
                <i class="fas fa-key"></i>
            </span>
            <span class="text">API Documentation</span>
        </li>
        <li class="dropdown-item" (click)="openReleaseNotes()">
            <span class="icon">
                <i class="far fa-file-alt"></i>
            </span>
            <span class="text">Release Notes</span>
            <span class="icon right">
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </span>
        </li>
        <li class="dropdown-item" (click)="openSupport()">
            <span class="icon">
                <i class="fa-regular fa-headset"></i>
            </span>
            <span class="text">Support</span>
            <span class="icon right">
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </span>
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li class="dropdown-item" (click)="openAbout()">
            <span class="icon">
                <i class="far fa-info-circle"></i>
            </span>
            <span class="text">About CERRIX</span>
        </li>
    </ul>
</div>
